import styled from 'styled-components';

import image from './image.svg';

export const Graphics = styled.img.attrs({ src: image })`
  padding: 32px 20px 0 20px;
  height: 256px;
`;
